import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-custom-video-player',
	styleUrls: ['./custom-video-player.component.css'],
	templateUrl: './custom-video-player.component.html'
})
export class CustomVideoPlayerComponent implements OnInit {
	@Input() videoPlayerConfiguration;
	@Input() videoPlayerdata;
	constructor() {}

	ngOnInit(): void {}
}
